const currentUser = {
  id: "",
  username: "",
  phone: "",
  email: "",
  nickname: "",
  client: "",
  forceChangePassword: false,
  roles: [],
  authorityList: [],
  roleNames: [],
  workNum: "",
  mqttToken: "",
  tokenClient: "",
  listenerNoticeTopicName: ""
};
const userJSON = window.localStorage.getItem("currentUser");
if (userJSON) {
  Object.assign(currentUser, JSON.parse(userJSON));
}
export default {
  //搜索框
  state: {
    currentUser
  },
  mutations: {
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user/index.js